(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-bedfit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__ebBedfit) return;
    window.__ebBedfit = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-eb-bedfit-set]') : null;
      if (!btn) return;
      var root = btn.closest('[data-eb-bedfit]');
      if (!root) return;
      var mode = btn.getAttribute('data-eb-bedfit-set');
      root.setAttribute('data-eb-setup', mode);
      var all = root.querySelectorAll('[data-eb-bedfit-set]');
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute('aria-pressed', all[i] === btn ? 'true' : 'false');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-more"] && !Shopify.designMode) return;
  try {
    
  /* Ebbrest: кнопки, счётчик и стрелки клавиатуры у карусели наборов (sections/eb-more.liquid).
     Ряд прокручивает браузер (scroll-snap), здесь только переход к соседней карточке и состояние панели.
     Автопрокрутки нет. При prefers-reduced-motion переход мгновенный. */
  (function () {
    'use strict';

    // Карусели на странице. В редакторе темы секция перерисовывается: её запись убирается по shopify:section:unload,
    // иначе обработчик держал бы снятую со страницы разметку.
    var live = [];

    function init(root) {
      if (root.__ebBundles) return;
      var track = root.querySelector('[data-eb-bundles-track]');
      var prev = root.querySelector('[data-eb-bundles-prev]');
      var next = root.querySelector('[data-eb-bundles-next]');
      var now = root.querySelector('[data-eb-bundles-now]');
      if (!track || !prev || !next) return;
      var slides = [].slice.call(track.children);
      if (slides.length < 2) return;
      root.__ebBundles = true;

      var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
      var current = -1;
      var frame = 0;
      // Карточка, к которой ряд ещё едет: второе нажатие во время движения считает от неё, а не от места, где ряд сейчас.
      var pending = null;
      var settle = 0;

      function left(i) {
        return slides[i].offsetLeft - slides[0].offsetLeft;
      }

      function maxScroll() {
        return track.scrollWidth - track.clientWidth;
      }

      // Номер карточки у левого края. В конце ряда последняя карточка к левому краю не доходит, поэтому конец проверяется отдельно.
      function index() {
        var x = track.scrollLeft;
        if (x >= maxScroll() - 2) return slides.length - 1;
        var best = 0;
        var gap = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(left(i) - x);
          if (d < gap) {
            gap = d;
            best = i;
          }
        }
        return best;
      }

      function setDisabled(button, off) {
        if (off) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      }

      function update() {
        frame = 0;
        var i = index();
        if (i === current) return;
        current = i;
        // aria-disabled, а не disabled: кнопка с disabled теряет фокус, когда ряд доходит до края.
        setDisabled(prev, i === 0);
        setDisabled(next, i === slides.length - 1);
        if (now) now.textContent = String(i + 1);
      }

      function base() {
        return pending === null ? index() : pending;
      }

      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        pending = i;
        window.clearTimeout(settle);
        settle = window.setTimeout(function () { pending = null; }, 250);
        var x = Math.min(left(i), maxScroll());
        if (track.scrollTo) track.scrollTo({ left: x, behavior: reduce.matches ? 'auto' : 'smooth' });
        else track.scrollLeft = x;
        return i;
      }

      track.addEventListener('scroll', function () {
        if (pending !== null) {
          window.clearTimeout(settle);
          settle = window.setTimeout(function () { pending = null; }, 150);
        }
        if (!frame) frame = window.requestAnimationFrame(update);
      }, { passive: true });
      // Смена ширины окна: один обработчик на все карусели (ниже), сюда он приходит через список.
      live.push({
        root: root,
        reset: function () {
          current = -1;
          if (!frame) frame = window.requestAnimationFrame(update);
        }
      });

      prev.addEventListener('click', function () {
        go(base() - 1);
      });
      next.addEventListener('click', function () {
        go(base() + 1);
      });

      // Стрелки влево и вправо, пока фокус внутри карусели. Фокус из карточки переходит на название новой карточки,
      // с кнопок панели не уходит.
      root.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        var from = base();
        var to = go(from + (event.key === 'ArrowRight' ? 1 : -1));
        event.preventDefault();
        if (to === from) return;
        var active = document.activeElement;
        if (active && track.contains(active)) {
          var target = slides[to].querySelector('[data-eb-bundles-focus]');
          if (target) target.focus({ preventScroll: true });
        }
      });

      update();
      root.classList.add('is-ready');
    }

    function scan(scope) {
      [].forEach.call((scope || document).querySelectorAll('[data-eb-bundles]'), init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    window.addEventListener('resize', function () {
      live = live.filter(function (item) { return item.root.isConnected !== false; });
      live.forEach(function (item) { item.reset(); });
    });
    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      live = live.filter(function (item) { return !event.target.contains(item.root); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
